import React from 'react';

import { Trans } from 'react-i18next';

import { useTimeAgo } from '@pkg/hooks';
import { type UtcMilliseconds } from '@pkg/types';

import { EmojiIcon, Label, StyledTimestampBadge } from './TimestampBadge.style';

export interface TimestampBadgeProps {
    timestamp?: UtcMilliseconds;
}

export function TimestampBadge({ timestamp = 0 }: TimestampBadgeProps) {
    const { label } = useTimeAgo(timestamp, { preferDaysOverWeeks: true });

    return (
        <StyledTimestampBadge>
            <EmojiIcon>⏰</EmojiIcon>

            <Label>
                <Trans ns="marketplace" i18nKey="asset-listing-sheet-summary-timer" values={{ timeAgo: label.compact }}>
                    <span>0</span>
                </Trans>
            </Label>
        </StyledTimestampBadge>
    );
}
